module.exports = __webpack_public_path__ + "img/productBanner4.611ce264.png";